import React from 'react'

import { useRemoteStrings } from '@acorns/web-utils'

import { POTENTIAL_DETAILS } from 'utils/testing/testIDs'

import {
  DetailContainer,
  DetailHeader,
  SectionIcon,
  Text,
  Title,
} from '../shared/SectionDetails'
import { usePotential } from './PotentialContext'

export const Details = (): React.ReactElement => {
  const { getRemoteString } = useRemoteStrings()
  const { selectedAge, projectedValue } = usePotential()

  return (
    <DetailContainer detailOnRight data-testid={POTENTIAL_DETAILS}>
      <SectionIcon sectionIndex={3} />
      <Title>
        {getRemoteString({
          key: 'early.recap.potential.header.variable',
          variables: [`${selectedAge}`],
        })}
      </Title>
      <DetailHeader isSmallFont>{projectedValue}</DetailHeader>
      <Text>
        {getRemoteString({
          key: 'early.recap.potential.subheader',
        })}
      </Text>
    </DetailContainer>
  )
}
